import { FC } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

import { FormLayout } from '@/components/Forms';
import FormField from '@/components/Forms/FormField';
import { VideoCompilerCompilation } from '@/types/resources';

import Card from '../../Create/components/Card';

const StyledCard = styled(Card)`
  height: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
`;

interface Props {
  compilation: VideoCompilerCompilation;
}

const Details: FC<Props> = ({ compilation }) => {
  const { control } = useForm({
    defaultValues: {
      title: compilation.title,
      thumb: '',
      watermark: '',
    },
  });

  return (
    <StyledCard>
      <FormLayout>
        <FormField
          control={control}
          name="title"
          label="Compilation Name"
          placeholder="Add name"
          disabled
        />
        {!!compilation.watermark && (
          <FormField
            id="watermark"
            label="Watermark"
            control={control}
            existingMedia={compilation.watermark}
            name="watermark"
            type="image"
            notes={'PNG only. Image Dimensions must be the same as video'}
            accept="image/png"
            disabled
          />
        )}
      </FormLayout>
    </StyledCard>
  );
};

export default Details;
